import { connect } from 'react-redux';
import DisplayAdSlot from './DisplayAdSlot';

function DisplayAd(props) {
  return <DisplayAdSlot {...props} />;
}

function mapStateToProps(state) {
  return {
    deregisterDisplaySlot: state.mint.deregisterDisplayAds,
  };
}

export default connect(mapStateToProps)(DisplayAd);
